import { createContext } from "react";

const ServerDataContext = createContext({})

export default ServerDataContext